import React from 'react';
import { LinkBase, Text } from '@belong/ui';
import type { BlogAuthor } from '../../constants';
import { AboutAuthor } from '../about-author/about-author';

type AuthorsListProps = {
  blogAuthors: BlogAuthor[];
};

export const AuthorsList: React.FC<AuthorsListProps> = ({
  blogAuthors = [],
}) => {
  return (
    <>
      <Text fontWeight="semibold" className="text-h3-sm">
        Meet Our Authors
      </Text>
      {blogAuthors.map((author) => {
        return (
          <div className="my-xs" key={author.uid}>
            <LinkBase href={`/blog/author/${author.uid}`}>
              <AboutAuthor
                author={{
                  // @ts-expect-error -- Legacy typecheck baseline; see docs/development/typecheck-baseline-followups.md. Refs: ARCH-56
                  profileImageUrl: author.data.profile_image_url.url,
                  firstName: author.data.first_name,
                  lastName: author.data.last_name,
                }}
                firstLine={
                  <Text as="h3" fontWeight="semibold">
                    {author.data.first_name} {author.data.last_name}
                  </Text>
                }
                secondLine={null}
                showImg
                variant="withHover"
              />
            </LinkBase>
          </div>
        );
      })}
    </>
  );
};
